import { getSintegradaServerApi } from "@/services/api";

import { User } from "@/@types/sintegrada/User";
import { ResumeGrouped } from "@/services/esus/attendanceService";
import { MedicalAttendanceFilterParams } from "@/@types/sintegrada/MedicalAttendanceFilterParams";
import { MedicalAttendanceTypeEnum } from "@/utils/enums/sintegrada/medicalAttendance/MedicalAttendanceTypeEnum";

export type MedicalAttendanceResumeByProfessional = ResumeGrouped<
	User,
	ResumeGrouped<MedicalAttendanceTypeEnum, object>
>[];

export async function getMedicalAttendanceResumeByProfessionals({
	uf,
	ibgeCode,
	cnes,
	...params
}: MedicalAttendanceFilterParams) {
	const url = `/attendance/medical-attendance-resume-by-professional`;

	const { data } = await getSintegradaServerApi().get<MedicalAttendanceResumeByProfessional>(
		url,
		{
			ibgeCode,
			cnes,
			...params,
		}
	);

	return data || ([] as MedicalAttendanceResumeByProfessional);
}
